module.exports = __webpack_public_path__ + "img/29.4ab84a46.jpg";